import React from "react";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import SimpleTabs from "./search";
import "./search.css";
class Body extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tvalue: "",
      subvalue: "",
      totalvalue: "",
    };
  }

  render() {
    const handleChange = (event, newValue) => {
      this.setState({
        tvalue: newValue,
        subvalue: Math.round((newValue / 100) * 5),
        totalvalue: this.state.subvalue + 50,
      });
    };
    return (
      <body>
        {/* <Routes value={false}/> */}
        <div class="hub">
          <div class="banner-sec d-flex justify-between align-center">
            <object
              aria-label="banner"
              alt="banner"
              data="./images/banner-pic.svg"
              type="image/svg+xml"
            ></object>
            <span>
              <h4>Control Hub</h4>
              <p>
                Build your own business instead of leasing in Amazon or ebay?
                Save 30% in Transaction Fees and build your marketplace. Choose
                the right approach for your idea, technical skills, and budget.
                Launch fast with a no-code solution or develop your unique
                marketplace on top of powerful APIs
              </p>
            </span>
          </div>
          {/* <div class="pricing">
         <h3 class="site-tit">Our Pricing</h3>
           <div class="container">
               <div class="slider-box d-flex align-center">
                   <div class="demo-slider">        
                       <div class="mbsc-form-group">
                           <div class="d-flex justify-between align-center flex-wrap slider-value-box">
                               <div class="trans_fee">
                                   <span>Transaction Fee 
                                    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><g transform="translate(-872 -87)" fill="none" fill-rule="evenodd"><path d="M881.856 101v-6.888h-1.862V101h1.862zm-2.086-9.142c0-.644.518-1.162 1.148-1.162.644 0 1.148.518 1.148 1.162 0 .616-.504 1.134-1.148 1.134-.63 0-1.148-.518-1.148-1.134z" fill="#000" fill-rule="nonzero"></path><circle stroke="#000" cx="881" cy="96" r="8.5"></circle></g></svg></span>
                                   <h2>${this.state.subvalue}/month<small></small></h2>
                               </div>
        
                            <span class="slider-op">+</span>
        
                            <div class="subs_fee">
                                <span>Subscription Fee</span>
                                <h2>$50/month</h2>
                            </div>
        
                            <span class="slider-op">
                                =
                            </span>
                            <div class="emc">
                                <span>Estimated monthly cost</span>
                                <h2>${this.state.totalvalue}/month</h2>
                            </div>
                           </div>
                           
                            <label class="mbsc-slider-primary">
                            <span class="min-v">$500</span>
                             <input mbsc-slider type="range" value="45" data-tooltip="true"/>
                            <div>
       <Typography id="non-linear-slider" gutterBottom>
      </Typography>
      <Slider
        value={this.state.tvalue}
        min={500}
        step={1}
        max={2500}
        //getAriaValueText={valueLabelFormat}
        // valueLabelFormat={valueLabelFormat}
        onChange={handleChange}
        valueLabelDisplay="on"
        aria-labelledby=""
      />
    </div> 
                            <span class="max-v">$2500</span>
                            </label>
                      </div>
                </div>
            </div>
         </div>
        </div>*/}

          <div class="readysoft">
            <div class="container">
              <h5 class="secnd-tit m-auto mb-2">Readymade Softwares</h5>
              <hr />
              <SimpleTabs />
            </div>
          </div>
          <div class="buildabusi">
            <div class="container">
              <div class="fty-hd">
                <h5 class="trd-tit m-auto mb-0">
                  Building a business takes time
                </h5>
                <p class="sub-tit m-auto">How About a Working Product </p>
              </div>
              <div class="busin-build">
                <span>
                  <object
                    alt="icon"
                    aria-label="icon"
                    data="./images/icons/ico-1.svg"
                    type="image/svg+xml"
                  ></object>
                  <p>No Hiring Personal</p>
                </span>
                <span>
                  <object
                    alt="icon"
                    aria-label=""
                    data="./images/icons/ico-2.svg"
                    type="image/svg+xml"
                  ></object>
                  <p>Readymade Design and Payment Gateway</p>
                </span>
                <span>
                  <object
                    alt="icon"
                    aria-label=""
                    data="./images/icons/ico-3.svg"
                    type="image/svg+xml"
                  ></object>
                  <p>
                    Integrated Marketplace Solutions to Start your Marketing
                  </p>
                </span>
                <span>
                  <object
                    alt="icon"
                    aria-label=""
                    data="./images/icons/ico-4.svg"
                    type="image/svg+xml"
                  ></object>
                  <p>Go Live in 3 Days</p>
                </span>
              </div>
            </div>
          </div>
          <div class="market-software d-flex justify-between align-center">
            <div class="m-auto">
              <h4>Start Buying Our Marketplace Software </h4>
              <div class="markrt-fst d-flex justify-evenly align-center">
                <ul class="list">
                  <li>Stable</li>
                  <li>Reliable</li>
                  <li>Scalable</li>
                </ul>
                <div class="market-btn">
                  <button class="orange-btn">Start Buying</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    );
  }
}
export default Body;
